export default __webpack_public_path__ + "static/media/magic-link-plus-message.4306169b.svg";